import { apiEmpleo } from "../../util/ApiEmpleo";

export const apiMarkMineWaAsDelivered = async () => {
  let res = await apiEmpleo.post(`notifications/mark-mine-wa-as-delivered`);
  return res;
};
